import { render, staticRenderFns } from "./UTM.vue?vue&type=template&id=015d9546&lang=pug&"
import script from "./UTM.vue?vue&type=script&lang=js&"
export * from "./UTM.vue?vue&type=script&lang=js&"
import style0 from "./UTM.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports